import React from "react";
import { useDispatch } from "react-redux";
import { Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { ACTIONS as MAIN_ACTIONS } from "../../../../redux/main";

import StyledLogOutButton from "./styles";

const LogOutButton = () => {
  const dispatch = useDispatch();

  const onLogOutClick = () => {
    dispatch(MAIN_ACTIONS.logOutUser());
  };
  return (
    <StyledLogOutButton onClick={onLogOutClick}>
      <div className="log-out-button">
        <LogoutIcon />
        <Typography>LogOut</Typography>
      </div>
    </StyledLogOutButton>
  );
};

export default LogOutButton;
